import _ from 'lodash';
import { toNumber } from '../functions';
import {
    FETCH_RAINPRO_SELLER_ORDERS,
    CLEAN_RAINPRO_SELLER_ORDERS,
    SYNC_RAINPRO_SELLER_ORDER,
    EDIT_RAINPRO_SELLER_ORDER,
    CHANGE_RAINPRO_SELLER_ORDER_STATE,
    PICKUP_RAINPRO_SELLER_ORDER,
    READY_RAINPRO_SELLER_ORDER,
} from '../actions/types';

const RAINPRO_SELLER_ORDERS_DEFAULT_STATE = {};

/**
 * Reducer pre objednavky.
 */
const RainproSellerOrdersReducer = (state = RAINPRO_SELLER_ORDERS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_RAINPRO_SELLER_ORDERS:
            return payload;

        case CLEAN_RAINPRO_SELLER_ORDERS:
            return RAINPRO_SELLER_ORDERS_DEFAULT_STATE;

        case EDIT_RAINPRO_SELLER_ORDER:
            // Editacia objednavky
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    // Nasli sme objednavku
                    item = { ...item, data: { ...item.data, ...payload.data } };
                }

                return item;
            }) };

        case CHANGE_RAINPRO_SELLER_ORDER_STATE:
            return { ...state, items: _.map(state.items, item => {
                if (!_.isEmpty(payload[toNumber(item.id)])) {
                    // Nasli sme objednavku zmenime data
                    item = { ...item, data: payload[toNumber(item.id)] };
                }

                return item;
            }) };

        case PICKUP_RAINPRO_SELLER_ORDER:
            return { ...state, items: _.map(state.items, item => {
                if (!_.isEmpty(payload.data[toNumber(item.id)])) {
                    // Nasli sme objednavku zmenime data
                    item = { ...item, data: payload.data[toNumber(item.id)] };
                }

                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, pickup: 1 };
                }

                return item;
            }) };

        case READY_RAINPRO_SELLER_ORDER:
            return { ...state, items: _.map(state.items, item => {
                if (!_.isEmpty(payload.data[toNumber(item.id)])) {
                    // Nasli sme objednavku zmenime data
                    item = { ...item, data: payload.data[toNumber(item.id)] };
                }

                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, ready: 1 };
                }

                return item;
            }) };

        case SYNC_RAINPRO_SELLER_ORDER:
            return { ...state, items: _.map(state.items, item => {
                if (!_.isEmpty(payload[toNumber(item.id)])) {
                    // Nasli sme objednavku zmenime data
                    item = { ...item, data: payload[toNumber(item.id)] };
                }

                return item;
            }) };

        default:
            return state;
    }
};

export default RainproSellerOrdersReducer;
